export class GlueCatalogPropertiesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogOwner",
            "baseName": "catalogOwner",
            "type": "CatalogOwner",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GlueCatalogPropertiesInput.attributeTypeMap;
    }
    constructor() {
    }
}
